import { useId } from 'react';

import { PlatformLocalUser } from '@cloudquery/api-platform';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

import { CloseButton } from 'shared/base';

interface Props {
  onClose: () => void;
  onConfirm: () => void;
  open: boolean;
  user?: PlatformLocalUser;
}

export function ResetMfaDialog({ onClose, onConfirm, open, user }: Props) {
  const labelId = useId();

  const handleResetMfa = async () => {
    onConfirm();
    onClose();
  };

  return (
    <Dialog
      aria-labelledby={labelId}
      fullWidth={true}
      onClose={onClose}
      open={open}
      slotProps={{
        paper: {
          sx: {
            bgcolor: 'background.paper',
            maxWidth: '400px',
            width: '100%',
          },
        },
      }}
    >
      <DialogTitle id={labelId} sx={{ paddingBottom: 0, paddingTop: 4 }}>
        <Box alignItems="center" display="flex" justifyContent="space-between">
          <Typography variant="h6">
            {user?.name ? `Reset MFA for ${user?.name}` : 'Reset MFA'}
          </Typography>
          <CloseButton onClose={onClose} />
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          {user?.name ? (
            <>
              Are you sure you want to reset MFA for {user?.name}? This user will be required to
              re-enroll in MFA on their next login.
            </>
          ) : (
            <>
              Are you sure you want to reset your MFA? You will be prompted to set up your MFA again
              before continuing.
            </>
          )}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={onClose} size="medium" variant="outlined">
          Cancel
        </Button>
        <Button color="error" onClick={handleResetMfa} size="medium" variant="contained">
          Confirm reset
        </Button>
      </DialogActions>
    </Dialog>
  );
}
